export default {"src":"/_next/static/media/no-petsitter.1efa2d01.svg","height":238,"width":379,"blurWidth":0,"blurHeight":0};